import { render, staticRenderFns } from "./CustomerInput.vue?vue&type=template&id=04e5dc95&scoped=true"
import script from "./CustomerInput.vue?vue&type=script&lang=js"
export * from "./CustomerInput.vue?vue&type=script&lang=js"
import style0 from "./CustomerInput.vue?vue&type=style&index=0&id=04e5dc95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e5dc95",
  null
  
)

export default component.exports